import React, { useEffect, useRef, Fragment } from 'react';
import { Flex, Box, Text, Button, Link, Image } from 'rebass/styled-components';
import { trackStatsService } from '../services/services';
import logo from '../../assets/images/aisle-mgmt-logo.png';

const SignUpIndex = ({ setStep }) => {
  let buttonRef = useRef();

  useEffect(() => {
    buttonRef.current.focus();
  }, []);

  const start = async () => {
    const data = {
      event: 'START'
    };
    try{
      let response = await trackStatsService(data);
      if (response.status == "200"){
        setStep("form");
      }
    }catch(error){
        console.log(error);
    };
  };

  return (
    <Fragment>
        <Flex
            flexDirection="column"
            justifyContent="center"
            mt={'40px'}
            px={[4, 15, 16]}
            pb={[3, 0]}
            height="auto"
            backgroundColor="screenBackground"
            minHeight="500px"
        >
            <Flex justifyContent="center" pb={[12, 15]}>
                <Image src={logo} alt="aiSLE MGMT"></Image>
            </Flex>

            <Text fontSize={['18px', '20px', '24px']} textAlign="center" pb={5}>
            Start using <strong>aiSLE MGMT</strong> with your rheumatologist or
            clinician.
            <br />
            <br />
            Complete this form to request an aiSLE MGMT Welcome Kit. The Welcome
            Kit includes information on the program and a test kit to use at your
            next lupus visit.
            </Text>
            <Text fontSize={['16px', '18px', '20px']} textAlign="center">
            <strong>Questions? Looking to learn more?</strong>
            <br />
            <Link href={`mailto:hello@aislemgmt.com`}> hello@aislemgmt.com</Link>
            <br />
            <br />
            Progentec powers aiSLE MGMT. Check out our{' '}
            <Link
                href="https://www.progentec.com/aisle-mgmt-patient"
                target="_blank"
            >
                privacy policy
            </Link>{' '}
            to learn more.
            </Text>
        </Flex>

        <Flex
            height="60px"
            backgroundColor="grey3"
            alignItems="center"
            width="100%"
            sx={{
            position: 'fixed',
            bottom: '0',
            zIndex: '1',
            borderTop: '1px solid #D6D6D6'
            }}
        >
            <Box width={1} px={2} my={2}>
            <Flex justifyContent="center">
                <Button
                    ref={buttonRef}
                    variant="main"
                    width={['100px', '120px']}
                    fontSize={['22px', '26px']}
                    onClick={() => start()}
                >
                Start
                </Button>
            </Flex>
            </Box>
        </Flex>
    </Fragment>
  );
};

export default SignUpIndex;
